import { common } from './common.icons';
export const DynamicIcon = ({ className = '', style = {}, children, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 230 150"
      stroke="currentColor"
      style={{ ...common.styles, ...style }}
      {...rest}
      className={`${className} dynamic-icon`}
    >
      {children}
    </svg>
  );
};
